import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
} from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";

export const APP_NAME = "Karrot INC";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const APP_PREFIX_PATH = "/app";
export const APP_NOADMIN_PREFIX_PATH = `${APP_PREFIX_PATH}/pos`;
export const AUTH_PREFIX_PATH = "/auth";
export const EXTERNAL_PREFIX_PATH = "/external";
export const REDIRECT_URL_KEY = "redirect";
export const UNAUTHENTICATED_ENTRY = "/login";
export const AUTHENTICATED_ENTRY = [
  `${APP_PREFIX_PATH}/start/shift-start`,
  `${APP_PREFIX_PATH}/home/`,
  `${APP_PREFIX_PATH}/home/`,
];

export const THEME_CONFIG_ADMIN = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
  blankLayout: false,
};

export const THEME_CONFIG_NOADMIN = {
  navCollapsed: true,
  sideNavTheme: SIDE_NAV_LIGHT,
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
  blankLayout: false,
};
